import { LoadingButton } from '@mui/lab';
import { Box, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { api } from 'src/Api';
import Iconify from 'src/components/Iconify';
import Page from 'src/components/Page';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import UploadListTable from 'src/layouts/UploadListCom/UploadListTable';

export default function UploadList() {
  const [list, setlist] = useState([]);
  const [loading, setloading] = useState(false);
  const token = localStorage.getItem('token');
  const [pagination, setPagination] = useState({});

  const [search, setsearch] = useState('');
  const [permission, setpermission] = useState([]);

  const requirement = [
    'visible',
    'add',
    'edit',
    'delete',
    'change status',
    'change role',
    'user invite'
  ];

  useEffect(() => {
    checkRender();
  }, []);

  function checkRender() {
    let check = 'upload list';
    const localPerm = JSON.parse(localStorage.getItem('permissions'))?.filter(
      (item) => item.permission_name.toLowerCase() == check
    );

    localPerm[0]?.permission_types?.filter((items) =>
      requirement.includes(items.permission_type_name.toLowerCase())
        ? setpermission((permissions) => [...permissions, items.permission_type_name.toLowerCase()])
        : false
    );
  }

  useEffect(() => {
    list.length = 0;
    getUploadData(pagination.current_page);
  }, [pagination.current_page]);

  useEffect(() => {
    if (search.length == 0) {
      list.length = 0;
      getUploadData(1);
    }
  }, [search]);

  function getUploadData(page) {
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const queryParams = new URLSearchParams();
    page && queryParams.append('page', page);
    search.length > 0 && queryParams.append('search', search);

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: myHeaders
    };

    fetch(`${api.get_my_files}?${queryParams.toString()}`, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to fetch Deal data');
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        setlist(result?.data);
        setPagination(result.pagination);
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {
        setloading(false);
      });
  }

  const refresh = () => {
    setlist([]);
    getUploadData();
  };

  const handlePageChange = (event, newPage) => {
    setPagination((prev) => ({ ...prev, current_page: newPage }));
  };

  return (
    <Page title={`Upload-List | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Typography
        sx={{
          fontSize: 25,
          fontFamily: 'poppinsSemiBold',
          padding: '0 10px 0 10px'
        }}
      >
        Upload List
      </Typography>

      <Box sx={{ px: 1.5, py: 2 }}>
        <Grid container spacing={2} alignItems="center" mb={2}>
          {/* Search + Search Button */}
          <Grid item xs={12} md={12}>
            <Grid container spacing={2} alignItems="center">
              {/* Searchbar */}
              <Grid item xs={12} sm={9} md={11}>
                <Searchbar
                  width="100%"
                  value={search}
                  setFunction={(val) => setsearch(val)}
                  className="width_full_property"
                  placeholder="Search..."
                  onEnter={() => {
                    list.length = 0;
                    getUploadData(1);
                  }}
                />
              </Grid>

              {/* Search Button */}
              <Grid item xs={12} sm={3} md={1}>
                <LoadingButton
                  fullWidth
                  sx={{ height: 33, borderRadius: 0.7 }}
                  variant="contained"
                  onClick={() => {
                    getUploadData(1);
                  }}
                >
                  <Iconify icon="material-symbols:search" sx={{ width: 20, height: 20 }} />
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <UploadListTable
          data={list}
          loading={loading}
          handlePageChange={handlePageChange}
          pagination={pagination}
        />
      </Box>
    </Page>
  );
}
